export const getDataFromScriptTag = (id: string) => {
    const target = document.getElementById(id);

    return target?.innerHTML ? JSON.parse(target.innerHTML) : undefined;
};
